import React from 'react'

import { Title, TitleSmall, StyledContainer } from './styles'

const HeaderTitle = props => (

    <StyledContainer page={props.page}>
        {props.size === 'small' ? 
            <TitleSmall theme={props.theme} align={props.align}>
                {props.label}
            </TitleSmall>
        :
            <Title theme={props.theme} align={props.align}>
                {props.label}
            </Title>
        }
    </StyledContainer>

)

export default HeaderTitle